import { Injectable } from '@angular/core';
import { ConfigService } from '../services/config.service';

@Injectable({ providedIn: 'root' })
export class MetaProvider {
  constructor(private config: ConfigService) {}

  clearHead() {
    this.resetTitle();
    this.removeDescription();
  }

  addTitle(content: string = '') {
    document.title = content;
  }

  removeDescription() {
    // Try to remove META-Tags
    try {
      document.querySelector('meta[name=\'description\']').remove();
    } catch (e) {}
  }

  resetTitle() {
    document.title = 'PlayBac Presse';
  }

  addDescription(content) {
    // Add the new META-Tags
    const description = document.createElement('meta');
    description.name = 'description';
    description.content = content;
    document.getElementsByTagName('head')[0].appendChild(description);
  }

  // addSmartBanner(newspaper){
  //   let seo = this.config.getSeoConfig();
  //   let app = seo[newspaper].iosapp.link;

  //   var description = document.createElement('meta');
  //   description.name = "apple-itunes-app";
  //   description.content = `app-id=${app}`;
  //   document.getElementsByTagName('head')[0].appendChild(description);
  // }

  setMetaData(page, newspaper) {
    const seo = this.config.getSeoConfig();
    const title = seo[newspaper] && seo[newspaper][page] ? seo[newspaper][page].title : '';
    const description = seo[newspaper] && seo[newspaper][page] ? seo[newspaper][page].description : '';
    if (title.indexOf('@journal@')) {
      const titlePlatform = title.replace('@journal@', seo[newspaper].name);
      this.addTitle(titlePlatform);
    } else {
      this.addTitle(title);
    }

    if (description.indexOf('@journal@')) {
      const descriptionPlatform = description.replace(
        '@journal@',
        seo[newspaper].name
      );
      this.addDescription(descriptionPlatform);
    } else {
      this.addDescription(description);
    }
  }
}
